import type { LineSeriesOption } from 'echarts';
import type { RetirementChartData, RetirementChartConfig } from './types';

// Two vertical reference lines on the (numeric) x-axis: Retirement Year and Life Expectancy.
// Each carries a boxed label at the top of the line, mirroring the AMCharts axisRanges.
export const buildRetirementMarkLine = (
  data: RetirementChartData,
  config: RetirementChartConfig,
): LineSeriesOption['markLine'] => {
  const { theme, retirementLineColor, lifeExpectancyLineColor } = config;

  // insideLeft pulls the label to the left of the line so a marker sitting at the right edge
  // (Life Expectancy is always the rightmost) doesn't clip against the grid; centered otherwise.
  const line = (xAxis: number, text: string, color: string, insideLeft = false) => ({
    xAxis,
    lineStyle: { color, width: 3, type: 'solid' as const, opacity: 1 },
    label: {
      show: true,
      formatter: text,
      // 'end' is the top of a vertical (xAxis) mark line.
      position: 'end' as const,
      ...(insideLeft ? { offset: [-60, 0] as [number, number] } : {}),
      color,
      fontSize: 14,
      fontWeight: 'bold' as const,
      backgroundColor: theme.bgColor,
      borderColor: color,
      borderWidth: 1,
      borderRadius: 3,
      padding: [5, 5] as [number, number],
    },
  });

  return {
    symbol: ['none', 'none'],
    silent: true,
    // Paint above every area band (series z maxes at 100); AMCharts: range.grid.above = true.
    z: 200,
    data: [
      line(data.retirementAge - 1, 'Retirement Year', retirementLineColor),
      line(data.lifeExpectancy, 'Life Expectancy', lifeExpectancyLineColor, true),
    ],
  };
};
